<template>
  <user-layout>
    <div class="mx-auto auth-page-container">
      <b-card class="auth-card" no-body>
        <div class="form-side">
          <main-logo />
          <div class="d-flex flex-column align-items-center text-center">
            <h3 class="mt-2 mb-2">{{ $t('pages.login.error-title') }}</h3>
            <p class="display-1 font-weight-bold my-3">404</p>
            <b-button type="submit" variant="primary" size="lg" class="btn-shadow text-uppercase" @click="goBack">{{
              $t('buttons.backHome')
            }}</b-button>
          </div>
        </div>
      </b-card>
    </div>
  </user-layout>
</template>
<script>
import { adminRoot } from '@/constants/config'
import UserLayout from '@/layouts/UserLayout'
import MainLogo from '@/components/Common/MainLogo'

export default {
  components: { UserLayout, MainLogo },
  methods: {
    goBack() {
      this.$router.push(adminRoot)
    }
  },
  mounted: function () {
    document.body.classList.add('background')
  },
  beforeDestroy() {
    document.body.classList.remove('background')
  }
}
</script>
